import { useEffect, useMemo, useState } from 'react';
import { getConnectedPipedreamApps } from '../../utils/PipeDreamUtil';
import POPULAR_APPS from './popularApps';

/**
 * Seeds the app-picker default options: the user's connected Pipedream apps first, then curated popular
 * apps (deduped by nameSlug), so the dropdown is useful before any search. The full catalog is still
 * searched live; this only provides the initial list. Shared by the inline node config and full-pane
 * template so the fetch + dedupe lives in one place.
 */
export default function useConnectedAppOptions() {
  const [connectedApps, setConnectedApps] = useState([]);

  useEffect(() => {
    getConnectedPipedreamApps()
      .then((apps) => setConnectedApps(apps))
      .catch(() => setConnectedApps([]));
  }, []);

  return useMemo(() => {
    const bySlug = new Map();
    [...connectedApps, ...POPULAR_APPS].forEach((app) => {
      if (app?.nameSlug && !bySlug.has(app.nameSlug)) bySlug.set(app.nameSlug, app);
    });
    return Array.from(bySlug.values());
  }, [connectedApps]);
}
